<template>

  
                <div>
                  <h3 class="text-center">Print Identitas</h3>
                  <div class="row mt-3 mb-3">
                    
                    <div class="col-12 text-center">
                      <button class="btn btn-info mr-3" style="width: 150px;" @click="printPage">Print</button>
                      <!-- <button class="btn btn-primary" style="width: 75px;" @click="$emit('closeModal')">Kembali</button> -->
                    </div>
                  </div>
                  <div style="border: 1px solid black">
  
                    <!-- PRINT WO START -->
                    <div id="printMe">
                      <print-header></print-header>  
  
                      <h3 class="pl-3">Print Identitas</h3>
                      <hr>
  
                      <div style="padding:0 30px">
                        <div class="row">
                            <div class="col-md-2">
                                <div style="margin-top:8px; font-size:14px; font-weight: 700;">KTP :</div>
                            </div>
                            <div class="col-md-10">
                                <img :src="env.baseImage + '/' + data.customer.ktp_img" style="max-height: 300px; max-width: 300px;">
                            </div>
                        </div>
                      </div>

                      <hr>
  
                      <div style="padding:0 30px">
                        <div class="row">
                            <div class="col-md-2">
                                <div style="margin-top:8px; font-size:14px; font-weight: 700;">SIM :</div>
                            </div>
                            <div class="col-md-10">
                                <img :src="env.baseImage + '/' + data.customer_car.sim_img" style="max-height: 300px; max-width: 300px;">
                            </div>
                        </div>
                      </div>

                      <hr>
  
                      <div style="padding:0 30px">
                        <div class="row">
                            <div class="col-md-2">
                                <div style="margin-top:8px; font-size:14px; font-weight: 700;">STNK :</div>
                            </div>
                            <div class="col-md-10">
                                <img :src="env.baseImage + '/' + data.customer_car.stnk_img" style="max-height: 300px; max-width: 300px;">
                            </div>
                        </div>
                      </div>
  
                    </div>
                    <!-- PRINT WO END -->
  
                  </div>
                  
                </div>

  </template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
    import printHeader from '@/components/print/print_header.vue'
    import env from '@/env'
  
    export default {
      data () {
        return {
          env,
          placeholder : require('@/assets/img/placeholder.png'),
          internalConditions : [],
          figureGrouping : {
            front : ['front_bumper', 'front_left_light', 'front_right_light', 'front_windshield', 'grill', 'left_fog_light', 'right_fog_light'],
            rear : ['rear_bumper', 'rear_left_light', 'rear_right_light', 'rear_windshield'],
            left : ['front_left_door', 'front_left_fender', 'front_left_wheel', 'rear_left_door', 'rear_left_fender', 'rear_left_wheel'],
            right : ['front_right_door', 'front_right_fender', 'front_right_wheel', 'rear_right_door', 'rear_right_fender', 'rear_right_wheel'],
            atap : ['roof', 'sunroof']
          },
          damages : {
            front : [],
            rear : [],
            left : [],
            right : [],
            atap : []
          },
          dictionary : [
            {key:'front', value:'Depan'},
            {key:'rear', value: 'Belakang'},
            {key:'left', value: 'Kiri'},
            {key:'right', value: 'Kanan'},
            {key:'atap', value: 'Atap'}
          ]
        }
      },
      props : ['form_code', 'data', 'estimationData', 'complete'],
      components:{
        MultiSelect,
        printHeader,
      },
      async mounted () {
        this.internalConditions = await this.parseInternalCondition(this.data.condition.checklist);
        await this.parseExternalCondition(this.data.condition.figure);
        // this.printPage();
      },
      watch : {
        'selected.woStep'(){
          this.form.step_id = this.selected.woStep ? this.selected.woStep.id : '';
        },
        'selected.laborer'(){
          this.form.labourer_id = this.selected.laborer ? this.selected.laborer.id : '';
        }
      },
      methods : {
        printPage(){
          this.$htmlToPaper('printMe');
        },
        parseInternalCondition(checklist){
          return Object.entries(checklist).map((x)=>{return {item:this.toCapitalizedWords(x[0].toLowerCase()), value:x[1]}})
  
          //Old Parser 2
          // return Object.keys(checklist).map((x)=>{return this.toCapitalizedWords(x.toLowerCase())})
  
          //Old Parser
          // var list = {}
          // for(var i in checklist) list[i.split("_")[0]] = 1;
          // return Object.keys(list).sort();
        },
        parseExternalCondition(figure){
          for(var i in figure){
            for(var j in figure[i]){
              if(figure[i][j]){
                this.damages[i].push(`Kerusakan '${this.toCapitalizedWords(j)}'. Deskripsi : '${figure[i][j].desc}'`)
              }
            }
          }
        },
      }
    }
  </script>
  
  <style scoped>
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  
  
  .companyDetails{
    margin-bottom: 5px;
    font-size:.6rem;
  }
  /* .documentTitle{
    font-size: 40px;
    border: 1px solid black;
    border-radius: 10px;
    padding:20px 30px;
  } */
  .contentTitle{
    margin-top:8px;
    font-size:14px;
    font-weight: 700;
  }
  .contentVariable{
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 14px;
  }
  
  </style>